import { GzClipContentWebComponent } from './component/GzClipContentWebComponent';

export { GzClipContentWebComponent };
